<main dir="rtl" class="text-start md:bg-white bg-[#F7F7F8] md:h-auto h-[100vh] md:px-0 px-5">
  <div dir="rtl" class="flex lg:flex-row flex-col-reverse">
    <div class="lg:w-1/2 w-full lg:h-screen 2xl:px-20 xl:px-16 md:px-12 px-8 md:py-20 py-10 bg-white md:rounded-none rounded-lg">
      <div [dir]="isRTL ? 'rtl' : 'ltr'" class="w-full flex justify-between items-center">
          <h1 class="2xl:text-xl xl:text-lg text-base font-semibold text-[#4B4B4B]">{{ 'auth.login.welcome' | translate }}</h1>
          <div class="relative inline-block">
            <div (click)="toggleLanguageDropdown()"
              class="cursor-pointer text-[#1F1F1F] border-[#D1D1DB] border py-2 px-3 rounded-full 2xl:text-xs text-[0.6rem] font-light flex items-center gap-2 select-none"
            >
            {{ 'common.languages.' + languageService.currentLang() | translate }}
            <i class="bi bi-chevron-down 2xl:text-[0.6rem] text-[0.5rem] transition duration-300" [class.rotate-180]="isLanguageOpen"></i>
            </div>

            <div *ngIf="isLanguageOpen"
              class="w-24 absolute mt-2 start-0 end-0 bg-white border border-gray-200 rounded-xl shadow-lg overflow-hidden z-50"
            >
              <button (click)="changeLanguage('ar')" class="w-full flex justify-end items-center gap-2 px-3 py-2 text-end hover:bg-gray-100 2xl:text-xs text-[10px] font-light cursor-pointer">
                {{ 'common.languages.ar' | translate }}
                <img src="shared/navbar/ar_flag.png" alt="" class="w-3 h-3">
              </button>
              <button (click)="changeLanguage('en')" class="w-full flex justify-end items-center gap-2 px-3 py-2 text-end hover:bg-gray-100 2xl:text-xs text-[10px] font-light cursor-pointer">
                {{ 'common.languages.en' | translate }}
                <img src="shared/navbar/en_flag.png" alt="" class="w-3 h-3">
              </button>
            </div>
          </div>
      </div>
      <form #loginForm="ngForm" class="my-8" (submit)="submit(loginForm)">

        <div class="input-group">
          <label dir="auto" for="email">
            {{ 'auth.fields.email' | translate }}<span class="text-red-500">*</span>
          </label>
          <input type="email" name="email" id="email" autocomplete="email" ngModel required email />
        </div>

        <div class="input-group">

          <label [dir]="isRTL ? 'rtl' : 'ltr'" for="password">
            {{ 'auth.fields.password' | translate }}<span class="text-red-500">*</span>
            <i class="bi bi-exclamation-circle-fill ms-2 text-sm text-[#D1D1DB]"
              [title]="'auth.password_requirements' | translate">
            </i>
          </label>

          <div [dir]="isRTL ? 'rtl' : 'ltr'" class="relative w-full">
            <input [type]="showPassword ? 'text' : 'password'" name="password" id="password" autocomplete="current-password" ngModel required minlength="8"
              class="w-full h-10 px-4 py-2 mt-2 text-sm border-2 border-[#4B4B4B] rounded-lg focus:outline-none focus:border-[#007AFF] ps-12 text-start" />

            <span (click)="togglePassword()" class="absolute inset-y-7.5 end-4 flex items-center cursor-pointer">
              <ng-container *ngIf="!showPassword; else eyeSlash">
                <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M15.25 7C15.25 8 13.5 13.25 8 13.25C2.5 13.25 0.75 8 0.75 7C0.75 6 2.5 0.75 8 0.75C13.5 0.75 15.25 6 15.25 7Z"
                    stroke="#8A8AA3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path
                    d="M10.25 7C10.25 8.24264 9.24264 9.25 8 9.25C6.75736 9.25 5.75 8.24264 5.75 7C5.75 5.75736 6.75736 4.75 8 4.75C9.24264 4.75 10.25 5.75736 10.25 7Z"
                    stroke="#8A8AA3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </ng-container>
              <ng-template #eyeSlash>
                <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M15.25 7C15.25 8 13.5 13.25 8 13.25C2.5 13.25 0.75 8 0.75 7C0.75 6 2.5 0.75 8 0.75C13.5 0.75 15.25 6 15.25 7Z"
                    stroke="#8A8AA3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path
                    d="M10.25 7C10.25 8.24264 9.24264 9.25 8 9.25C6.75736 9.25 5.75 8.24264 5.75 7C5.75 5.75736 6.75736 4.75 8 4.75C9.24264 4.75 10.25 5.75736 10.25 7Z"
                    stroke="#8A8AA3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M1 1L15 13" stroke="#8A8AA3" stroke-width="1.5" stroke-linecap="round" />
                </svg>
              </ng-template>
            </span>
          </div>

        </div>
        <div dir="auto" class="mb-5">
          <input type="checkbox" name="remember" id="remember" />
          <label for="remember" class="ms-2 2xl:text-sm text-xs">{{ 'auth.login.remember_me' | translate }}</label>
        </div>

        <button class="submit-button flex justify-center items-center gap-2" type="submit" [disabled]="loginForm.invalid || disableButton">
          <span *ngIf="loading" class="w-3 h-3 border border-t-0 border-white rounded-full animate-spin"></span>
          {{ 'auth.login.submit' | translate }}
        </button>
        <p dir="auto" class="mt-5 2xl:text-sm text-xs">
          {{ 'auth.login.forgot_password_question' | translate }}
          <a [routerLink]="['/reset-password']" class="text-blue-800 ms-3">{{ 'auth.login.reset_password_link' | translate }}</a>
        </p>
      </form>
    </div>

    <div class="bg-[url('/auth/bg.jpg')] bg-cover bg-center lg:w-1/2 w-full h-screen md:block hidden">
      <div class="h-full w-full flex flex-col justify-center items-center gap-4">
        <div class="max-w-4/5 h-4/5">
          <app-promo-card></app-promo-card>
        </div>

        <div class="w-full flex 2xl:gap-6 xl:gap-5 gap-3.5 justify-center items-center">
          <div class="text-white font-semibold 2xl:text-base xl:text-sm lg:text-xs text-xs">
              <p>
                {{ 'auth.login.credits_designed_by' | translate }}
              </p>
              <p>Devzonez Solutions</p>
          </div>
          <div class="w-[1px] h-full bg-white"></div>
          <img src="auth/devzones-logo.png" alt="Logo"
            class="2xl:h-[24px] xl:h-[16px] lg:h-3.5 h-3.5 brightness-0 invert" />
        </div>
      </div>
    </div>

    <div class="flex justify-center items-center">
      <img src="shared/colored_text_logo.svg" alt="Promo Card" class="w-[85px] md:hidden my-8" />
    </div>
  </div>
</main>
